export default {
    title: "Dom",
    button: {
        accessories: "Przeglądaj katalog"
    },
    noAvailableItems: "W portalu peryferyjnym nie ma obecnie żadnych elementów dostępnych dla Twojego kraju. Współpracuj ze swoim kierownikiem, aby zdobyć potrzebne elementy.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Skontaktuj się z pomocą techniczną</a>",
    error: "Podczas pobierania produktów wystąpił problem. Proszę odświeżyć swoją przeglądarkę."
}